import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import { usePendingTimesheets } from 'hooks/api/useDashboard';

interface Props {
  managerId?: string;
  weekStartDate?: string;
}

const PendingTimesheetsWidget: React.FC<Props> = ({ managerId, weekStartDate }) => {
  const { data, loading } = usePendingTimesheets(managerId, weekStartDate);

  return (
    <div className="dashboard-widget">
      <div className="dashboard-widget-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <IconSystem.clock size={18} />
          <h3 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 600 }}>Pending Timesheets</h3>
        </div>
        <span className="badge badge-pending" style={{ fontSize: '1rem', fontWeight: 700 }}>
          {data?.pendingCount ?? 0}
        </span>
      </div>
      <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.5rem' }}>
        Current week — not yet submitted
      </div>
      <div style={{ flex: 1, overflow: 'auto', maxHeight: 220 }}>
        {loading ? (
          <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
            Loading...
          </div>
        ) : !data?.employees?.length ? (
          <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
            All timesheets submitted \u2713
          </div>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {data.employees.map(emp => (
              <li key={emp.employeeId} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.4rem 0',
                borderBottom: '1px solid var(--border-color)',
                fontSize: '0.8rem',
              }}>
                <span>{emp.employeeName} {emp.employeeCode && <span style={{ color: 'var(--text-muted)' }}>({emp.employeeCode})</span>}</span>
                <span className={`badge ${emp.statusCode === 'DRAFT' ? 'badge-pending' : 'badge-inactive'}`}>
                  {emp.statusName}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PendingTimesheetsWidget;
